import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { getGuestId, checkGuestInMySQL, checkUserInMySQL } from "../utils/guest";
import FashionStyleBuilder from "../components/FashionStyleBuilderNewUI";
import Toastbox from "../components/Toastbox"; // ✅ Import new Toastbox
import "../styles/button_styles.css"; // Custom styles
import { Box, CircularProgress, Dialog } from "../utils/mui-imports";
import { useLocation } from "react-router-dom";
import BlockBackButton from "../components/BlockBackButton";
import BlockBackButtonWithLimit from "../components/BlockBackButtonWithLimit";

async function out_of_credits_trigger(user){
  try {
    const response = await fetch("/api/out_of_credits_event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: user.email, external_id: user.uid, username: user.username }),
    });

    if (!response.ok) throw new Error(`Failed to trigger Out of Credit Event`);
    return await response.json();
  } catch (error) {
    console.error(`Error Triggering out of credit event:`, error);
    return null;
  }
}


const CurateLookPage = () => {
  const { user } = useAuth();
  const [credits, setCredits] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation()
  const [guestId, setGuestId] = useState(null);
  console.log("pathname - ", location.pathname)

  useEffect(() => {
    console.log('user - ', user);
    
    async function fetchCredits() {
      if (user) {
        const userData = await checkUserInMySQL(user.uid);
        setCredits(userData?.credits || 0);
        // setCredits(0)
        // Should we just trigger an API call here - email, userid available
        if(userData.credits <= 0){
          try{
            out_of_credits_trigger(user);
          } catch {
            console.log("Out of credit Brevo Event trigger failed");
          }
          
        }

      } else {
        const guestId = await getGuestId();
        const guestData = await checkGuestInMySQL(guestId);
        setCredits(guestData?.credits || 0);
        setGuestId(guestId)
        // setCredits(1)
        console.log('guestData - ', guestData);
      }
      setLoading(false);
    }

    fetchCredits();
   
  }, [user]);

  return (
    <div className="">
      <BlockBackButton/>        
        {loading ? (
          <Box
          height={"100%"}
          width={"100%"}
          sx={{
            display:'flex',
            alignItems:'center',
            justifyContent:'center'
          }}
          >
            <CircularProgress/>

          </Box>
        ) : (
          <>

          {(credits <= 0) && (
                    <Toastbox 
                    status={user ? "Signed in as a user" : "Browsing as a guest"}
                    credits={credits}
                    isUser={!!user}
                    guestId={!guestId? null : guestId}
                    redirectURL={location.pathname}
                    
                    
                  />
                )}
                 
              <FashionStyleBuilder 
               status={user ? "Signed in as a user" : "Browsing as a guest"}
               credits={credits}
               isUser={!!user}
              user={user} />
           
          </>
        )} 
      </div>
 
  );
};

export default CurateLookPage;
